<template>
  <ButtonView
    class="clara-launcher is-rounded has-background-white overflow-hidden p-x-12 p-y-8"
    :class="{ 'is-animating': isAnimating }"
    :aria-label="$t('ai.clara-for-planners.open-launcher-aria')"
    :data-e2e="AICypressAttribute.buttons.CLARA_FOR_PLANNERS_LAUNCHER"
    @click="onClick"
  >
    <span class="clara-launcher-stars is-relative is-flex-shrink-0">
      <svg
        class="clara-launcher-star-large is-absolute is-block"
        viewBox="0 0 17.4901 16.9697"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5272 7.54209C11.8681 7.44781 9.69967 5.353 9.71326 0.942761C9.69683 0.697966 9.5893 0.467331 9.4107 0.293868C9.23211 0.120405 8.99465 0.0159568 8.74262 0C8.48519 0 8.2383 0.0993256 8.05627 0.276128C7.87424 0.45293 7.77197 0.692725 7.77197 0.942761C7.7545 5.38505 5.58997 7.48552 0.963874 7.54209C0.836407 7.54295 0.710364 7.5682 0.592941 7.61638C0.475519 7.66456 0.369016 7.73473 0.279514 7.82288C0.098757 8.00092 -0.0017782 8.24141 2.38134e-05 8.49145C0.00182583 8.74148 0.105817 8.98058 0.289123 9.15615C0.472428 9.33171 0.720032 9.42936 0.977463 9.42761H0.98911C5.63656 9.42761 7.73121 11.4659 7.77197 16.0269C7.77192 16.2737 7.87152 16.5107 8.04937 16.687C8.22722 16.8633 8.46915 16.9648 8.72321 16.9697H8.74262C8.99186 16.97 9.23166 16.8772 9.41236 16.7104C9.59306 16.5437 9.7008 16.3158 9.71326 16.0741C9.94622 11.5488 12.0894 9.42761 16.4554 9.42761C16.4735 9.42855 16.4916 9.42855 16.5097 9.42761C16.7671 9.43011 17.0151 9.33318 17.1989 9.15815C17.3828 8.98311 17.4875 8.74431 17.4901 8.49427C17.4926 8.24424 17.3928 8.00345 17.2126 7.82488C17.0324 7.64631 16.7846 7.54459 16.5272 7.54209Z"
          fill="url(#clara-star-gradient)"
        />
        <defs>
          <linearGradient
            id="clara-star-gradient"
            x1="0"
            y1="8.48485"
            x2="17.4901"
            y2="8.48485"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="var(--ce-primary)" />
            <stop offset="1" stop-color="var(--ce-tertiary)" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        class="clara-launcher-star-small is-absolute is-block"
        viewBox="0 0 7.50706 7.27273"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.85427 4.24242H6.8755C7.04117 4.24419 7.20078 4.18204 7.31921 4.06963C7.43764 3.95722 7.5052 3.80377 7.50702 3.64303C7.50885 3.48229 7.44478 3.32744 7.32893 3.21253C7.21307 3.09762 7.05491 3.03207 6.88925 3.0303C5.14523 2.99515 4.37692 2.24727 4.37692 0.606061C4.37102 0.447146 4.30332 0.296292 4.18743 0.183849C4.07154 0.0714067 3.91606 0.00571861 3.75227 0C3.5866 0 3.42772 0.0638528 3.31058 0.177511C3.19343 0.29117 3.12762 0.445323 3.12762 0.606061C3.12762 2.25818 2.34806 3.00606 0.62029 3.0303C0.53826 3.03086 0.457146 3.04709 0.381581 3.07806C0.306015 3.10903 0.237476 3.15414 0.179878 3.21081C0.0635539 3.32527 -0.00114434 3.47987 1.53248e-05 3.64061C0.00117499 3.80134 0.0680974 3.95505 0.186061 4.06791C0.304025 4.18078 0.463368 4.24355 0.629035 4.24242H0.63653C2.3668 4.24242 3.11263 4.9697 3.12762 6.66667C3.12759 6.82533 3.19168 6.97767 3.30614 7.09099C3.42059 7.2043 3.57628 7.26956 3.73978 7.27273H3.75227C3.91266 7.27292 4.06699 7.21325 4.18328 7.10606C4.29956 6.99888 4.3689 6.8524 4.37692 6.69697C4.46312 5 5.22769 4.24242 6.85427 4.24242Z"
          fill="url(#clara-star-gradient-small)"
        />
        <defs>
          <linearGradient
            id="clara-star-gradient-small"
            x1="0"
            y1="3.63636"
            x2="7.50706"
            y2="3.63636"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="var(--ce-primary)" />
            <stop offset="1" stop-color="var(--ce-tertiary)" />
          </linearGradient>
        </defs>
      </svg>
    </span>

    <span
      class="clara-launcher-label is-flex-shrink-0 is-size-4 has-text-weight-semibold has-text-centered"
    >
      {{ $t('ai.clara-for-planners.ask-clara') }}
    </span>
  </ButtonView>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default defineComponent({
  name: 'ClaraForPlannersLauncher',
  emits: ['open'],
  components: {
    ButtonView
  },
  props: {
    isAnimating: {
      type: Boolean,
      default: false
    }
  },
  static: {
    AICypressAttribute
  },
  methods: {
    onClick(): void {
      this.$emit('open');
    }
  }
});
</script>

<style scoped>
.clara-launcher {
  height: 48px;
  border: 1px solid var(--ce-primary);
  box-shadow: 4px 6px 16px 0 rgba(255, 134, 91, 0.25), -4px 4px 16px 0 rgba(66, 93, 246, 0.25);

  &:hover,
  &:focus {
    border-color: var(--ce-primary);
  }

  &:focus:not(:active) {
    box-shadow: 4px 6px 16px 0 rgba(255, 134, 91, 0.25), -4px 4px 16px 0 rgba(66, 93, 246, 0.25);
  }

  &:hover {
    box-shadow: 6px 8px 20px 0 rgba(255, 134, 91, 0.35), -6px 6px 20px 0 rgba(66, 93, 246, 0.35);
  }

  &:active {
    box-shadow: 2px 3px 8px 0 rgba(255, 134, 91, 0.2), -2px 2px 8px 0 rgba(66, 93, 246, 0.2);
  }
}

/* Kept out of the nested block: nested :deep() compiles to "& [data-v] > span", which never matches. */
.clara-launcher :deep(> span) {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.clara-launcher-stars {
  width: 20px;
  height: 20px;
}

.clara-launcher-star-large {
  left: 0;
  top: 15.15%;
  width: 87.45%;
  height: 84.85%;
}

.clara-launcher-star-small {
  left: 62.46%;
  top: 0;
  width: 37.54%;
  height: 36.36%;
}

.clara-launcher-label {
  width: 69px;
  line-height: normal;
  background: linear-gradient(90deg, var(--ce-primary), var(--ce-tertiary));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.clara-launcher:not(.is-animating) {
  .clara-launcher-label {
    width: 0;
    opacity: 0;
    margin: 0;
    overflow: hidden;
  }
}

.clara-launcher.is-animating {
  .clara-launcher-stars {
    animation: clara-stars 8s linear forwards;
  }

  .clara-launcher-label {
    animation: clara-label 8s linear forwards;
  }
}

@keyframes clara-stars {
  0% {
    opacity: 0;
    transform: translateX(0) scale(1) rotate(0deg);
  }
  8.75% {
    opacity: 1;
    transform: translateX(0) scale(1) rotate(0deg);
  }
  45% {
    opacity: 1;
    transform: translateX(0) scale(1) rotate(0deg);
    animation-timing-function: ease-out;
  }
  48.75% {
    transform: translateX(0) scale(1.3) rotate(0deg);
    animation-timing-function: ease-in-out;
  }
  50% {
    transform: translateX(2px) scale(1.3) rotate(-8deg);
  }
  53.75% {
    transform: translateX(2px) scale(1) rotate(0deg);
    animation-timing-function: ease-out;
  }
  57.5% {
    transform: translateX(2px) scale(1.3) rotate(0deg);
    animation-timing-function: ease-in-out;
  }
  58.75% {
    transform: translateX(2px) scale(1.3) rotate(-8deg);
  }
  62.5% {
    transform: translateX(2px) scale(1) rotate(0deg);
  }
  100% {
    opacity: 1;
    transform: translateX(2px) scale(1) rotate(0deg);
  }
}

@keyframes clara-label {
  0% {
    opacity: 0;
    width: 69px;
    transform: translateX(-8px);
  }
  8.75% {
    opacity: 0;
    width: 69px;
    transform: translateX(-8px);
    animation-timing-function: ease-out;
  }
  21.25% {
    opacity: 1;
    width: 69px;
    transform: translateX(0);
  }
  30% {
    opacity: 1;
    width: 69px;
    transform: translateX(0);
    animation-timing-function: ease-in-out;
  }
  36.25% {
    opacity: 0;
    width: 69px;
    transform: translateX(0);
    animation-timing-function: ease-in-out;
  }
  46.25% {
    opacity: 0;
    width: 0;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    width: 0;
    transform: translateX(0);
  }
}
</style>
